import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import CrmSidebar from "./sidebar";
import { TopNav } from "../navbar";
import useIsMobile from "../../hook/use-is-mobile";

const CrmDashboardLayout = () => {
  const isMobile = useIsMobile();
  // Below md: an off-canvas drawer, closed by default. At/above md: the
  // existing always-visible collapse-to-rail sidebar, open by default.
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobile);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  // Reset to the sensible default whenever crossing the mobile breakpoint
  // (e.g. resizing the window or rotating a tablet), without fighting a
  // manual toggle made while staying on the same side of the breakpoint.
  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        handleCloseSidebar();
      }
    };

    if (sidebarOpen && isMobile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen, isMobile]);


  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="mx-auto flex min-h-screen bg-[#F1F5F9] dark:bg-gray-950 md:h-screen overflow-hidden">
      {/* Backdrop — mobile only, shown while the drawer is open */}
      {showSidebar && sidebarOpen && isMobile && (
        <div className="fixed inset-0 bg-black/40 z-40 md:hidden" onClick={handleCloseSidebar} />
      )}

      {/* Sidebar — off-canvas drawer on mobile, always-visible collapse-rail on md+ */}
      {showSidebar && (
        <aside
          ref={sidebarRef}
          className={`fixed inset-y-0 left-0 z-50 h-screen w-[275px] transition-all duration-300 md:z-auto md:sticky md:top-0 ${
            sidebarOpen ? "translate-x-0 md:w-[275px]" : "-translate-x-full md:translate-x-0 md:w-[88px]"
          }`}
        >
          <CrmSidebar open={sidebarOpen} onToggle={toggleSidebar} />
        </aside>
      )}

      {/* Main Content */}
      <main id="page-scroll-container" className="flex-1 overflow-y-auto">
        <div className="min-h-full p-4">
          <TopNav onMenuClick={toggleSidebar} />
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default CrmDashboardLayout;